
angular.module('bmsApp.directives')
	.directive('submitFormBtn', function () {
		return {
			restrict: 'E',
			scope: {
				submittedWhen: '=',
				disabledIf: '=',
				submitText: '@',
				processingText: '@',
				whenClicked: '&whenClicked',
				classes: '@',
			},
			replace: true,
			template: '<button class="btn btn-primary {{classes}}" type="submit" ng-click="whenClicked()" ng-disabled="disabledIf || submittedWhen">' +
				'<ng-switch on="submittedWhen">' +
				'<span ng-switch-when="false">{{ submitText }}</span>' +
				'<span ng-switch-when="true">{{ processingText }} <img src="images/shared/submit-loader.gif"></span>' +
				'</button>',
			link: function (scope, element, attrs) {
				scope.submitText = (!angular.isUndefined(attrs.submitText)) ? attrs.submitText : "Submit";
				scope.processingText = (!angular.isUndefined(attrs.processingText)) ? attrs.processingText : "Saving";
			}
		};
	});







